import { render, staticRenderFns } from "./PortraitFields.vue?vue&type=template&id=32904730&scoped=true"
import script from "./PortraitFields.vue?vue&type=script&lang=js"
export * from "./PortraitFields.vue?vue&type=script&lang=js"
import style0 from "./PortraitFields.vue?vue&type=style&index=0&id=32904730&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32904730",
  null
  
)

export default component.exports